/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.offres.ts
 *
 * Messages de l'écran « Offres d'emploi » du back-office (/admin/jobs) :
 * toutes les offres du salon sur un document, avec exports XLSX et PDF.
 * Fusionné dans fr.ts, comme fr.personne.ts.
 *
 * Mikael - chef de projet - 2026-09-20
 */
export const messagesOffresFr: Record<string, string> = {
  'adminNav.jobs': "Offres d'emploi",

  'offres.titre': "Offres d'emploi",
  'offres.sousTitre':
    "Toutes les offres saisies par les exposants, avec l'entreprise, le stand, le référent et le compte qui les a déposées.",
  'offres.chargement': 'Chargement des offres…',
  'offres.erreur.chargement': "Impossible de charger les offres. Réessayez dans un instant.",
  'offres.degrade':
    "Certaines informations (secteurs, stands, candidatures) n'ont pas pu être lues : la liste est complète, mais partielle sur ces colonnes.",
  'offres.coordonneesMasquees':
    "Les coordonnées (courriels, téléphones) ne sont pas affichées : votre compte n'y a pas accès.",

  'offres.tuile.offres': 'offres',
  'offres.tuile.postes': 'postes à pourvoir',
  'offres.tuile.entreprises': 'entreprises',
  'offres.tuile.publiees': 'offres publiées',
  'offres.tuile.candidatures': 'candidatures reçues',

  'offres.filtre.recherche': 'Rechercher',
  'offres.filtre.recherchePlaceholder': 'Intitulé, entreprise, lieu, description',
  'offres.filtre.contrat': 'Contrat',
  'offres.filtre.secteur': 'Secteur',
  'offres.filtre.publication': 'Publication',
  'offres.filtre.tous': 'Tous',
  'offres.filtre.toutes': 'Toutes',
  'offres.filtre.publieesSeules': 'Publiées seulement',
  'offres.filtre.nonPubliees': 'Non publiées seulement',
  'offres.filtre.effacer': 'Effacer les filtres',
  'offres.filtre.resultat': '{n, plural, =0 {Aucune offre} one {# offre} other {# offres}} dans la sélection',

  'offres.export.xlsx': 'Exporter en Excel',
  'offres.export.pdf': 'Exporter en PDF',
  'offres.export.aide': "L'export reprend exactement la sélection affichée, filtres compris.",

  'offres.vue.entreprises': 'Par entreprise',
  'offres.vue.liste': 'Liste à plat',

  'offres.entreprise.stand': 'Stand',
  'offres.entreprise.standAucun': 'Stand non attribué',
  'offres.entreprise.secteur': 'Secteur',
  'offres.entreprise.referent': 'Référent',
  'offres.entreprise.saisiePar': 'Saisie par',
  'offres.entreprise.candidatureSpontanee': 'Candidatures spontanées',
  'offres.entreprise.site': 'Site',
  'offres.entreprise.pageOffres': 'Page offres',
  'offres.entreprise.pageCandidature': 'Page candidature',
  'offres.entreprise.presentation': 'Présentation aux candidats',
  'offres.entreprise.fichePubliee': 'Fiche publiée',
  'offres.entreprise.ficheNonPubliee': 'Fiche non publiée',
  'offres.entreprise.fiche': 'Fiche complète',
  'offres.entreprise.nbOffres': '{n, plural, one {# offre} other {# offres}}',
  'offres.entreprise.nbPostes': '{n, plural, one {# poste} other {# postes}}',

  'offres.colonne.intitule': 'Intitulé du poste',
  'offres.colonne.entreprise': 'Entreprise',
  'offres.colonne.contrat': 'Contrat',
  'offres.colonne.postes': 'Postes',
  'offres.colonne.secteur': 'Secteur',
  'offres.colonne.experience': 'Expérience',
  'offres.colonne.lieu': 'Lieu',
  'offres.colonne.description': 'Description',
  'offres.colonne.publiee': 'Publiée',
  'offres.colonne.candidatures': 'Candidatures',
  'offres.colonne.dates': 'Créée / modifiée',

  'offres.offre.nonPrecise': 'Non précisé',
  'offres.offre.publiee': 'Publiée',
  'offres.offre.nonPubliee': 'Non publiée',
  'offres.offre.creee': 'Créée le {date}',
  'offres.offre.modifiee': 'modifiée le {date}',
  'offres.offre.sansDescription': 'Sans description.',

  'offres.sansEntreprise.titre': "Entreprises sans offre",
  'offres.sansEntreprise.texte':
    "{n, plural, one {# entreprise n'a} other {# entreprises n'ont}} encore déposé aucune offre.",

  'offres.vide': 'Aucune offre ne correspond à la sélection.',
  'offres.aucune': "Aucun exposant n'a encore déposé d'offre.",
};
